import React from 'react';
import { Star, Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  role: string;
  location: string;
  content: string;
  initials: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  content,
  initials
}: TestimonialCardProps) {
  return <div className="bg-white rounded-2xl shadow-lg p-8 relative border border-gray-100 h-full flex flex-col" data-id="element-264">
      <Quote className="absolute top-6 right-6 h-8 w-8 text-green-100" data-id="element-265" />

      <div className="flex items-center mb-6" data-id="element-266">
        <div className="h-12 w-12 rounded-full bg-green-100 flex items-center justify-center text-green-700 font-bold text-lg mr-4 border-2 border-green-200" data-id="element-267">
          {initials}
        </div>
        <div data-id="element-268">
          <h3 className="font-bold text-gray-900" data-id="element-269">{name}</h3>
          <p className="text-sm text-gray-500" data-id="element-270">{role}</p>
          <p className="text-xs text-green-600 font-medium" data-id="element-271">{location}</p>
        </div>
      </div>

      <div className="flex mb-4" data-id="element-272">
        {[...Array(5)].map((_, i) => <Star key={i} className="h-4 w-4 text-yellow-400 fill-current" data-id="element-273" />)}
      </div>

      <p className="text-gray-700 italic leading-relaxed flex-grow" data-id="element-274">
        "{content}"
      </p>
    </div>;
}